<template>
  <div :class="$style.box">
    <h1 :class="$style.slogan">
      <!-- 文字logo -->
      <span :class="$style.textLogo">
        <span :class="$style.textLogoCorner">「</span>
        <img
          :class="$style.svgTextLogo"
          src="@/assets/SOApplication.svg"
          width="230"
        >
        <span :class="$style.textLogoTitle">{{ content.studioName }}</span>
        <span :class="$style.textLogoCorner">」</span>
      </span>
      {{ content.slogan1 }}
      <br>
      {{ content.slogan2 }}
      <br>
      {{ content.slogan3 }}
    </h1>
  </div>
</template>

<script>

export default {
  name: 'KeyView',
  props: ['content']

}
</script>

<style module>

.box {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slogan {
  top: 54px;
  width: 100%;
  max-width: 1100px;
  font-size: 43px;
  font-weight: bold;
  vertical-align: center;

}

.textLogo {
  position: relative;
  top: -8px;
  margin-left: -42px;
  margin-right: -20px;
}
.textLogoCorner {
  opacity: 0.3;
}

.svgTextLogo {
  position: relative;
  /* margin-left: 4px; */
  margin-right: 8px;
  top: 4px;
}
.textLogoTitle {
  font-size: 32px;
  /* font-weight: normal; */
}

</style>
